import { Injectable } from '@angular/core';
import { UserDataService } from '../services/user-data.service';
import { ReportSaveService } from './report-save.service';
import { StateService } from '../services/state.service';
import { MongoService } from '../services/mongo.service';

@Injectable({
  providedIn: 'root'
})
export class UnregisteredUsersWithDevicesReportService {

  constructor(
    public userDataService: UserDataService,
    private savingService: ReportSaveService,
    private stateService: StateService,
    private mongoService: MongoService
  ) { }

  public async generateReport() : Promise<void> {
    try {
      const allUsersData = await this.userDataService.getAllExistingUsersData();
      const unregisteredUsersData = await this.getUnregisteredUsersWithDevices(allUsersData);
      const allUsersContactsData = await this.mongoService.getAllUsersContactsData();

      const state = this.stateService.getState();
      const isPumpState = state === "state-pumps";
      const isACState = state === "state-airconditioners";
      const preparedData = this.mergeByUserEmail(unregisteredUsersData, allUsersContactsData, { isPumpState, isACState });

      const reportData = this.generateReportContent(preparedData);
      this.save(reportData);
    } catch(e) {
      console.warn(e);
    }
  }

  private async getUnregisteredUsersWithDevices(usersData: Array<any>): Promise<Array<any>> {
    const unregisteredUsers: Array<any> = [];
    const state = this.stateService.getState();
    const isPumpState = state === 'state-pumps';
    const isACState = state === 'state-airconditioners';
  
    usersData.forEach(user => {
      if (!user.registered) {
        const hasPumpProducts = isPumpState && user.pumpRegisteredProducts?.length > 0;
        const hasACProducts = isACState && user.airConditionRegisteredProducts?.length > 0;
  
        if (hasPumpProducts || hasACProducts) {
          unregisteredUsers.push(user);
        }
      }
    });
  
    return unregisteredUsers;
  }

  private generateReportContent(rankingArray: Array<any>): Array<Array<any>> {
    const result: Array<Array<any>> = [];
    result.push(this.generateReportHeader());
    result.push(['']);
  
    let iterator = 1;
  
    rankingArray.forEach(user => {
  
        result.push([
          user.userEmail, 
          user.registeredProductsCount,
          user.companyName, 
          user.firstName, 
          user.lastName, 
          user.phoneNumber, 
          user.voivodeship,
          user.streetName,
          user.buildingNumber,
          user.city,
          user.postalCode
        ]);
        iterator++;
      
    });

    // sortowanie po kolumnie "voivodeship" (czyli po indeksie 6)
    // pomijamy pierwsze dwa wiersze: nagłówek i pustą linię
    const header = result[0];
    const emptyRow = result[1];
    const dataRows = result.slice(2);

    dataRows.sort((a, b) => {
      const aVal = (a[6] || '').toString().toLowerCase();
      const bVal = (b[6] || '').toString().toLowerCase();
      return aVal.localeCompare(bVal, 'pl');
    });

    return [header, emptyRow, ...dataRows];
  
    // return result;
  }

  private generateReportHeader() : Array<string> {
    return [
      'Adres email', 
      'Liczba urządzeń',
      'Nazwa firmy', 
      'Imię', 
      'Nazwisko', 
      'Nr telefonu', 
      'Województwo',
      'Ulica',
      'Numer',
      'Miejscowość',
      'Kod'
    ];
  }

  private save(data: Array<Array<any>>) : void {
    const state = this.stateService.getState();
    const type = state === "state-pumps" ? '_pompy' : (state === "state-airconditioners" ? '_klimatyzacja' : '');
    this.savingService.saveXlsxReport(data, `niezarejestrowani_z_urzadzeniami${type}.xlsx`, 'Raport')
  }

  /**
   * Łączy dane z dwóch tablic po userEmail i dodaje licznik zarejestrowanych produktów.
   * @param {Array<Object>} baseArr       - pierwsza tablica (z listami *RegisteredProducts)
   * @param {Array<Object>} detailsArr    - druga tablica (dane adresowe)
   * @param {{isPumpState?: boolean, isACState?: boolean}} opts - wybór trybu liczenia
   * @returns {Array<Object>}
   */
  mergeByUserEmail(baseArr:any, detailsArr:any, { isPumpState = false, isACState = false } = {}) {
    const wantedFields = [
      'firstName',
      'lastName',
      'companyName',
      'nipCode',
      'phoneNumber',
      'streetName',
      'buildingNumber',
      'city',
      'postalCode',
      'voivodeship'
    ];

    const detailsMap = new Map(
      (detailsArr || []).map((d:any) => [(d.userEmail || '').toLowerCase(), d])
    );

    return (baseArr || []).map((b:any) => {
      const key = (b.userEmail || '').toLowerCase();
      const d:any = detailsMap.get(key);

      const merged:any = { userEmail: b.userEmail || '' };

      // Pola z drugiej tablicy lub pusty string
      for (const f of wantedFields) {
        merged[f] = d && d[f] != null ? d[f] : '';
      }

      // Liczba zarejestrowanych produktów z pierwszej tablicy – wg przekazanych flag
      merged.registeredProductsCount = isPumpState
        ? (b.pumpRegisteredProducts?.length ?? 0)
        : (isACState
            ? (b.airConditionRegisteredProducts?.length ?? 0)
            : 0);

      return merged;
    });
  }
}
